import axios from "axios"

const API_BASE_URL = process.env.REACT_APP_BACKEND_API_URL || "http://localhost:5000/api"

const client = axios.create({
  baseURL: API_BASE_URL,
})

// Add token to requests
client.interceptors.request.use((config) => {
  const token = localStorage.getItem("token")
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

export default client
